import React, { useState } from 'react'
import "./TeamLdCare.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Autoplay} from "swiper/modules"
import { useNavigate } from 'react-router-dom';
import CalendlyFormModal from '../CalendlyFormEmbed/CalendlyFormEmbed';



function TeamLdCare({
    heading="The Experts Behind Your",
    spanHeading="Care",
    paragraph="Meet the multidisciplinary team supporting your health goals—thoughtfully assembled for their clinical excellence and patient-first mindset.",
    showBtn=true,
    cardData=null,
    noSwiper=false,
    learnMoreLink="/service",
    btnCalnedly=false,
    calendlyType=0,
    noLearnMoreAnchor=false,
    customBtnText="",
    imgBg=false,
    cusBlueBtnRef=""
}) {
     const handlePrevButtonClick = () => {
        const swiperInstance = document.querySelector('#team-cards-slider').swiper;
        swiperInstance.slidePrev();
      };
      
      const handleNextButtonClick = () => {
        const swiperInstance = document.querySelector('#team-cards-slider').swiper;
        swiperInstance.slideNext();
      };

      let teamList = [
    {
        id:1,
        link:`/team-individual/${1}`,
        // img:"/images/team/1.png",
        img:"/images/creatives/1.png",
        name:"Dr. Fabio Varlese ",
        rank:"MD, MSc, FRCPC",
        // para:'Dr. Varlese’s work is dedicated to enhancing the quality of life and developing innovation to reduce unnecessary suffering from preventable diseases by treating symptoms and early warning signs of disease.'
        para:'Dr. Varlese’s work is dedicated to enhancing the quality of life and developing innovation to reduce unnecessary suffering from preventable diseases by treating symptoms and early warning signs of disease.'
    },
    // {
    //     id:2,
    //     link:`/team-individual/${2}`,
    //     img:"/images/creatives/team-2.png",
    //     name:"Dr. Giuseppe Papia",
    //     rank:"MD, MSc, FRCSC",
    //     para:' Dr. Giuseppe Papia is a Vascular Surgeon part of of the Division of Cardiac and Vascular Surgery and the Division of Critical Care Medicine at Sunnybrook Health Sciences Centre.'
    // }
]

      if(cardData)
      {
        teamList = cardData
      }

      const navigate  = useNavigate()
    const [openCalendly, setOpenCalendly] = useState(false);
  return (
    <div className='TeamLdCare-container'>
         {
                  openCalendly &&
                  <CalendlyFormModal intialOpenState={openCalendly} setOpenState={setOpenCalendly} calendlyType={calendlyType}/>
              }
        <div className='container'>
            <div className='row align-items-start'>
                {
                    teamList.length == 1 ?
                <div className={`col-lg-6 pt-3`}>
                    <h3 className='body-heading'><span className='color-blue'>{heading} </span>{spanHeading}</h3>
                    <p className='body-paragraph'>{paragraph}</p>
                    {
                        showBtn &&
                            <div className='d-flex gap-3 mt-4 flex-lg-row flex-column px-lg-0 px-5 flex-wrap'>
                                <button className='genral-btn-narrow ' onClick={()=>{if(btnCalnedly) {setOpenCalendly(true)}else{if(cusBlueBtnRef){navigate(cusBlueBtnRef)}else{navigate("/membership")}}}}>{btnCalnedly ? "Book a consultation":`${customBtnText?customBtnText:"Explore membership"}`}</button>
                                {!noLearnMoreAnchor && <button className={`genral-btn-white color-dark ps-1 pe-0`} onClick={()=>{navigate(learnMoreLink)}}>Learn more →</button>}
                            </div>
                    }
                </div>

                    :
                <div className={`${!noSwiper ? "col-lg-5":"col-lg-5"} pt-3`}>
                    <h3 className='body-heading'><span className='color-blue'>{heading} </span>{spanHeading}</h3>
                    <p className='body-paragraph'>{paragraph}</p>
                    {
                        showBtn &&
                            <div className='d-flex gap-3 mt-4 flex-lg-row flex-column px-lg-0 px-5 flex-wrap'>
                                <button className='genral-btn-narrow ' onClick={()=>{if(btnCalnedly) {setOpenCalendly(true)}else{if(cusBlueBtnRef){navigate(cusBlueBtnRef)}else{navigate("/membership")}}}}>{btnCalnedly ? "Book a consultation":`${customBtnText?customBtnText:"Explore membership"}`}</button>
                                {!noLearnMoreAnchor && <button className={`genral-btn-white color-dark ps-1 pe-0`} onClick={()=>{navigate(learnMoreLink)}}>Learn more →</button>}
                            </div>
                    }
                </div>
                }
                    {
                        teamList.length == 1 ?
                <div className={`col-lg-6`}>
                    
                        <div className='team-card'>
                           
                                {/* <div className='mb-3' style={{backgroundImage:`url(${teamList[0]?.img})`,backgroundSize:"cover",backgroundRepeat:"no-repeat",minHeight:"400px",width:"100%",borderRadius:"20px"}}></div> */}
                            <img src={teamList[0]?.img} className='img-fluid mb-3' alt='team member' style={{borderRadius:"20px"}}/>
                            <div className='ps-1'>
                                <h3 className='sub-heading' style={{fontWeight:`${!noSwiper?"":"bolder"}`,fontSize:`${!noSwiper?"":"1.1rem"}`}}>{teamList[0]?.name}</h3>
                                <p className='color-dark'>{teamList[0]?.rank}</p>
                                <b className='color-dark mt-3'>Founder of The Toronto Clinic</b>
                                <p className='body-paragraph mt-3'>{teamList[0]?.para}</p>
                                <button className={`genral-btn-white color-blue ps-1`} style={{fontWeight:"800"}} onClick={()=>{navigate(teamList[0]?.link)}}>Learn more →</button>
                            </div>
                            
                        </div>
                            
                        </div>
                        :
                    <div className={`${!noSwiper ? "col-lg-7":"col-lg-7"}`}>
                        <Swiper
                            spaceBetween={60}
                            
                            loop={true}
                            // modules={[Autoplay]}
                            navigation={
                                {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                                }
                                }
                            breakpoints={{
                                200:{
                                slidesPerView: 1,
                                },
                                1100: {
                                slidesPerView: 2,
                                }
                            }}
                            pagination={{ clickable: true }}
                            observer ={true}
                            observeParents={true}
                            parallax={true}
                            className=" px-3 px-md-5 py-4"
                            style={{position:"relative"}}
                            id="team-cards-slider"
                            >
                        {
                                teamList.map((ele,ind)=>{
                                return(<>
                                    <SwiperSlide>
                                        <div className='team-card'>
                                            {
                                                imgBg?
                                                <div className='mb-3' style={{backgroundImage:`url(${ele?.img})`,backgroundSize:"cover",backgroundRepeat:"no-repeat",minHeight:"230px",width:"100%",borderRadius:"20px"}}></div>
                                                :
                                                <img src={ele?.img} className='img-fluid mb-3' alt='team member' style={{borderRadius:"20px"}}/>
                                            }
                                            <div className='ps-1'>
                                                <h3 className='sub-heading' style={{fontWeight:`${!noSwiper?"":"bolder"}`,fontSize:`${!noSwiper?"":"1.1rem"}`}}>{ele?.name}</h3>
                                                <p className='color-dark'>{ele?.rank}</p>
                                                <p className='body-paragraph mt-3'>{ele?.para}</p>

                                                <button className={`genral-btn-white color-blue ps-1`} style={{fontWeight:"800"}} onClick={()=>{navigate(ele?.link)}}>Learn more →</button>
                                            </div>
                                            
                                        </div>
                                    </SwiperSlide>
                
                                    </>)
                                })
                            }
                            {
                                !noSwiper &&
                                <div className="swiper-button-next swiper-button d-lg-block d-none" onClick={handleNextButtonClick}>
                                <img src="/images/icons/indus-carousel-arrow-right.png" className="arrow-img"/>
                                </div>
                            }
                        </Swiper>
                </div>
                    }

            </div>
        </div>
    </div>
  )
}

export default TeamLdCare